/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = window.GetAllOrgLicenseLookups = function() {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetAllIndLicenseLookups: {
        $xmlns: 'http://dobs.pa.gov/sc/lookup/bpm/1.0'
      }
    },
    blueprintArrays: [
      'GetAllindLicenseLookupsResponse.IndLicenseTypes.SC_LU_IndLicenseType',
      'GetAllindLicenseLookupsResponse.IndLicenseStatuses.SC_LU_IndLicenseStatus'
    ],
    blueprint: {
      indLicenseTypes: [
        '$..SC_LU_IndLicenseType',
        {
          id: '$..ID',
          type: '$..Type'
        }
      ],
      indLicenseStatuses: [
        '$..SC_LU_IndLicenseStatus',
        {
          id: '$..ID',
          status: '$..Status'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
